import { INotification } from '@gik/ui';
import { INotificationsContext } from './context';

export default class NotificationStore {
  private _context;

  constructor(context: INotificationsContext) {
    this._context = context;
  }

  add(item: INotification) {
    this._context.add(item);
  }

  remove(notificationId: string) {
    this._context.remove(notificationId);
  }

  removeAll() {
    this._context.removeAll();
  }
}
